import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { isUndefined } from 'lodash';
import {
  ITrackingAction,
  ITrackingObject,
} from '../../../tracking/tracking.data';
import { FormAlignmentsEnum } from '../../form-master.enum';
import { CustomFormFieldComponent } from '../custom-form-field/custom-form-field.component';

export interface IValueSwitch {
  key: string;
  value: string | number | boolean;
  trackingObject?: ITrackingObject;
  trackingAction?: ITrackingAction;
  trackingAdditionalProperties?: any;
}

@Component({
  selector: 'app-value-switch-field',
  templateUrl: './value-switch-field.component.html',
  styleUrls: ['./value-switch-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ValueSwitchFieldComponent),
      multi: true,
    },
  ],
})
export class ValueSwitchFieldComponent
  extends CustomFormFieldComponent
  implements ControlValueAccessor, OnInit, OnChanges {
  @Input() alignment: FormAlignmentsEnum;
  @Input() label: string;
  @Input() fieldId: string;
  @Input() description: string;
  @Input() switches: List<IValueSwitch>;
  @Input() formControl: AbstractControl;

  selectedValue: string | number | boolean;
  disabled: boolean;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    translateService: TranslateService
  ) {
    super(changeDetectorRef, translateService);
  }

  ngOnChanges(changes) {
    if (changes.formControl && this.formControl && this.fieldControl) {
      this.fieldControl.reset(
        {
          value: this.formControl.value,
          disabled: this.formControl.disabled,
        },
        {
          emitEvent: false,
        }
      );
    }
  }

  ngOnInit() {
    this.fieldControl = this.formControl;

    super.ngOnInit();
  }

  writeValue(value: any) {
    if (!isUndefined(value)) {
      this.selectedValue = value;
    }
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;

    this.changeDetectorRef.markForCheck();
  }

  onClick(value: string | number | boolean) {
    this.selectedValue = value;

    this.propagateChange(value);
  }
}
